export default "__VITE_ASSET__DtoP0X1q__"